<template>
  <div class="hello page-roster">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>财务</el-breadcrumb-item>
          <el-breadcrumb-item>财务数据源</el-breadcrumb-item>
          <el-breadcrumb-item>导入记录</el-breadcrumb-item>
          <el-breadcrumb-item>数据源校验详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="customerRosterTable">
        <div class="dlt_btn">
           <el-button v-if="(tableData.length>0&&!isNull(tableData))" type="success" plain size="mini" @click="exportHandle" :loading="btnLoading">导出</el-button>
        </div>
        <el-table :data="tableData" :max-height="tableHeight-180" v-loading="tableLoading" border style="width: 99%" :cell-style="columnStyle" :lazy="true">
          <!-- <el-table-column align="center" type="selection" width="40"></el-table-column> -->
          <template v-for="(item,index) in tableTitle">
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit  :key="index" :width="item.StrColumName=='备注' ? 380 : (item.StrColumName=='NO'? 60 : (item.StrColumName=='姓名'? 100 : 180)) " align="center" :fixed="item.StrColumName=='项目名称' || item.StrColumName=='姓名'">
              <template slot-scope="scope">
                <!-- <div v-if="item.StrColumName.indexOf('收入')!=-1 || item.StrColumName.indexOf('金')!=-1 || item.StrColumName.indexOf('支出')!=-1 || item.StrColumName.indexOf('结余')!=-1 || item.StrColumName.indexOf('商保')!=-1 || item.StrColumName.indexOf('险')!=-1 || item.StrColumName.indexOf('个人承担')!=-1">
                  {{!isNull2(scope.row[item.StrColumId]) ? Number(scope.row[item.StrColumId]).toLocaleString(undefined,{minimumFractionDigits:2}):''}}
                </div> -->
                <div v-if="item.StrColumName=='插入时间'||item.StrColumName.indexOf('日期')!=-1">{{isNull(scope.row[item.StrColumId]) ? '' : scope.row[item.StrColumId].substring(0, 10)}}</div>
                <div v-else-if="item.StrColumName=='身份证号码'">{{scope.row[item.StrColumId]}}</div>
                <div v-else>{{scope.row[item.StrColumId]}}</div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block" v-if="Number(totalcount)>0">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="listQuery.currpage" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" :page-size="listQuery.pagecount" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>
        </div>
      </div>
    </div>

    <div class="dialog">
      <!-- 删除 -->
      <el-dialog :visible.sync="delDialog" width="580px">
        <div class="diaTitle">清除 {{dltTableName}} 数据</div>
        <div class="flex impdata" style="margin:20px 0">
          <div class="bookkeepingMonth">
            <div class="impTitle">记账月份:</div>
            <el-date-picker v-model="dltQuery.bookingRealMonth" type="month" placeholder="选择月" :picker-options="pickerOptions" value-format="yyyy-MM" @change="selectMonth"></el-date-picker>
          </div>
          <div class="bookkeepingMonth">
            <div class="impTitle">归属月份:</div>
            <el-date-picker v-model="dltQuery.belongMonth" type="month" placeholder="选择月" :picker-options="pickerOptions" value-format="yyyy-MM" @change="selectMonth"></el-date-picker>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" style="margin-right:15px" @click="delDialog = false">取消</el-button>
          <!-- <el-popconfirm :title="'确认要删除  ' + dltTableName + '  的所有数据'" icon="el-icon-info" icon-color="red" @confirm="confirmDel"> -->
            <el-button size="medium" slot="reference" type="danger" @click="confirmDel">确认删除</el-button>
          <!-- </el-popconfirm> -->
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import xz from "../../common";
import { parseTime } from '../../utils' //格式化时间格式
export default {
  name: "checkDetail",
  data() {
    return {
      delDialog:false,
      dltTableName:'',
      //归属月份
      belongMonth: parseTime(new Date(), '{y}-{m}'),
      //记账月份
      bookDate: parseTime(new Date(), '{y}-{m}'),
      //禁用日期范围
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        'firstDayOfWeek': 1
      },
      strTableId: "",
      //表格高度
      tableHeight: 0,
      tableLoading: false,
      tableclumn: [],
      //表头内容
      tableTitle: [],
      totalcount: 0,
      //下拉筛选
      showDropScreen: -1,
      tableData: [],
      //删除数据参数
      dltQuery:{
        strObjName: '',
        tableid: '',
        bookingRealMonth: '',
        belongMonth: ''
      },
      listQuery:{
        pagecount:10,
        currpage:1,
        strexcelpath:'',
        belongMonth:''
      },
      // 导出参数
      exportQuery:{
        pagecount:1000000,
        currpage:1,
        strexcelpath:'',
        belongMonth:''
      },
      btnLoading:false
    };
  },
  created() {
    let a = 3023.46;
    // console.log('toFixed',a.toFixed(2).toLocaleString())
    let q = this.$route.query;
    this.listQuery.strexcelpath = q.strExcelPath
    this.listQuery.belongMonth = q.belongMonth
    this.dltQuery.tableid = q.StrTableId
    this.calHeight()
    this.getTableTitle()
  },
  methods: {
    async selectMonth(date) {
      console.log('month', date)
    },
    // 导出
    exportHandle(){
        this.exportQuery.strexcelpath = this.listQuery.strexcelpath
        this.exportQuery.belongMonth = this.listQuery.belongMonth
        this.btnLoading = true
      xz.getOutFnncDataSourceErr(this.exportQuery).then(res => {
        // console.log('导出', res)
        if (res.status == 'ok') {
          this.$router.push({
            path: "/employee-fnnchis",
            query: {
              showPage: 1,
              isActive: 1,
              custname: res.msg,
              //qStstus=1时查看最后一条导出记录
              qStstus: 1
            }
          })
        } else {
          this.$message({
            message: "导出失败，请稍后再试",
            type: "error"
          })
        }
        this.btnLoading = false
      })
    },
    //清除数据
    deleteHandle() {
      this.dltQuery.bookingRealMonth = "";
      this.dltQuery.belongMonth = "";
      this.delDialog = true;
    },
    //确认删除
    confirmDel() {
      if( this.strTableId != 'XZ_emp_FnncProCost'){
        if (this.isNull2(this.dltQuery.belongMonth) || this.isNull2(this.dltQuery.bookingRealMonth)) {
          this.$message.warning("请选择记账月份和归属月份")
          return false
        }
      }else{
        if (this.isNull2(this.dltQuery.bookingRealMonth)) {
          this.$message.warning("请选择记账月份")
          return false
        }
      }
      xz.delfnncuserimport(this.dltQuery).then(res => {
          if (res) {
            this.$message.success("删除成功！");
             setTimeout(() => {
              this.getImprtInfo();
            }, 1000);
            this.delDialog = false;
          } else {
            this.$message.fileid("删除失败！");
            this.delDialog = false;
          }
        })
    },
    //获取表格高度
    calHeight() {
      this.tableHeight = Number(document.documentElement.clientHeight);
      console.log('height', this.tableHeight)
    },
    //翻页
    handleCurrentChange(val) {
      this.listQuery.currpage = Number(val)
      this.getList()
    },
    //改变列表加载数量
    handleSizeChange(val) {
    //   console.log(`每页 ${val} 条`);
        this.listQuery.currpage = 1
        this.listQuery.pagecount = Number(val)
        this.getList()
    },
    // 获取列表
    getList(){
        this.tableLoading = true
        xz.getFinanceDataImpError(this.listQuery).then(res => {
        // console.log('列表', res)
        if (res.status == 'ok') {
          this.tableData = res.msg
          this.totalcount = res.totalcount
        } else {
          this.tableData = []
          this.totalcount = 0
        }
        this.tableLoading = false
      })
    },
     // 获取列表表头
    getTableTitle(){
      xz.getJbPageColumnDefList('XZ_emp_FnncDataSourceErrout').then(res => {
        // console.log('表头', res)
        if (res.status == 'ok') {
          this.tableTitle = res.msg
          this.getList()
        } else {
          this.tableTitle = []
        }
      })
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == []  || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01';
    },
    isNull2(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o === '' || o == 'null' || o == []
    },
    //去重
    unique(arr) {
      const resList = new Map();
      return arr.filter((arr) => !resList.has(arr.name) && resList.set(arr.name, 1));
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    //格式出错字体变红
    columnStyle({ row, column, rowIndex, columnIndex }) {
      // console.log( row, column, rowIndex, columnIndex)
      if (row.repeatJudge == 'true') {
        if (column.label == "档案号") {
          return "background-color:rgb(255,199,206)";
        }
        if (column.label == "身份证号码") {
          return "background-color:rgb(255,199,206)";
        }
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-tabs--top{
  width: 99%;
  background-color: #fff;
}
.page-roster .search {
  height: 32px;
  padding: 5px 15px;
  margin-right: 10px;
  border-radius: 5px;
  background-color: #ebfaf5;
  border: 1px solid #62d2b4;
  color: #19bd92;
}
.historyFiled {
  margin-top: 20px;
}
.historyFiled .el-radio-group {
  display: inline-block !important;
  margin-right: 10px;
  margin-top: 10px;
}
.result-box {
  padding: 15px 10px;
  border-radius: 5px;
  background-color: rgba(103, 194, 58, 0.1);
}
.file-box {
  position: relative;
}
:focus {
  outline: 0;
}
.top-right {
  display: flex;
  align-items: center;
}
.top-right .el-button--text {
  padding: 7px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}

.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: relative;
  top: 5px;
  left: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.selectCell {
  display: flex;
}
.lineTitle {
  line-height: 48px;
}
.page-roster .dlt_btn{
  display:flex;
  justify-content: flex-end;
  background:#fff;
  padding:10px 0 10px 0;
  width:99%;
}
.dlt_btn .el-button{
  margin-right: 15px;
}
</style>


<style >
.customerRosterTable .el-table td {
  padding: 8px 0;
}
.customerRosterTable .el-table th {
  padding: 12px 0;
}

.el-popper[x-placement^="bottom"] {
  margin-top: 5px;
}

.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}
.searchArea {
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.searchArea .el-select .el-input {
  height: 30px;
  width: 130px;
  border-right: none;
}
.searchArea .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.input-with-select {
  width: 430px;
}
.searchArea .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.searchArea .el-input__icon {
  line-height: 30px;
}
.drop-downMenu .el-dropdown .el-dropdown-link {
  cursor: pointer;
}
.direction .el-button {
  padding: 8px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.editInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.editInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .inputs {
  flex-wrap: wrap;
}
.dialog .el-drawer__body {
  overflow-y: scroll;
}
.fieldBox .el-checkbox__label {
  width: 120px !important;
  margin-bottom: 10px;
}
.storageInput .el-input--small .el-input__inner {
  width: 368px;
  height: 32px;
}
.storageInput .el-input--small {
  width: 360px;
}
.storageArea .upload-demo {
  height: 32px;
}
.storageArea .el-button--primary {
  background-color: #fff;
  color: #000;
  border-color: #ccc;
}
.el-button--primary:focus,
.el-button--primary:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
.storageArea .el-button {
  padding: 9px 15px;
}
.el-drawer__body span:focus {
  outline: 0 !important;
}
.dialog .el-tabs--border-card > .el-tabs__content {
  max-height: 200px;
  overflow-y: scroll;
}
.dialog .el-card__body {
  max-height: 208px;
  overflow-y: scroll;
}
.tagArea .el-tag + .el-tag {
  margin-left: 10px;
}
.tagArea .el-checkbox_input.is-focus .el-checkbox_inner {
  border-color: #19bd92;
}
.tagArea .el-checkbox__input.is-checked .el-checkbox__inner,
.tagArea .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #19bd92;
  border-color: #19bd92;
}
.tagArea .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #19bd92;
}
.tagArea .el-checkbox__inner:hover {
  border-color: #19bd92;
}
.tagArea .el-tag--plain.el-tag--success {
  color: #19bd92;
}
.tagArea
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  color: #19bd92;
}
.tagArea .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #19bd92;
}
.tableEditInput .el-input__inner {
  height: 25px;
  line-height: 25px;
  text-align: center;
  padding: 0;
  font-size: 13px;
}
.tableEditInput .el-input__icon {
  line-height: 25px;
}
.el-select-dropdown__item.selected {
  color: #19bd92 !important;
}
.historyFiled .el-radio-group {
  display: flex;
}
.exactDate .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.exactDate .el-input__icon {
  line-height: 32px;
}
.block .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 160px
}
</style>